import { ConfigService } from "../config.service";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import {
  BrowserCacheLocation,
  Configuration,
  IPublicClientApplication,
  PublicClientApplication
} from "@azure/msal-browser";
import { MsalModule, MsalService, MSAL_INSTANCE } from "@azure/msal-angular";

export function MSALInstanceFactory(
  config: ConfigService
): IPublicClientApplication {
  const settings = config.getBrowserAuthOptions();
  const msalConfig: Configuration = {
    auth: settings,
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  };

  return new PublicClientApplication(msalConfig);
}

@NgModule({
  providers: [],
  imports: [MsalModule]
})
export class MsalConfigDynamicModule {
  static forRoot() {
    return {
      ngModule: MsalConfigDynamicModule,
      providers: [
        ConfigService,
        provideAppInitializer(() => {
          const configService = inject(ConfigService);
          return configService.init();
        }),
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
          deps: [ConfigService]
        },
        MsalService
      ]
    };
  }
}
